// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__2XxQS","leftSide":"Navbar_leftSide__3T8Zs","rightSide":"Navbar_rightSide__2TIcW"};